import { render, staticRenderFns } from "./userDetails.vue?vue&type=template&id=c3cc25e2&scoped=true"
import script from "./userDetails.vue?vue&type=script&lang=js"
export * from "./userDetails.vue?vue&type=script&lang=js"
import style0 from "./userDetails.vue?vue&type=style&index=0&id=c3cc25e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cc25e2",
  null
  
)

export default component.exports